import script from "./CotizacionCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./CotizacionCreate.vue?vue&type=script&setup=true&lang=js"

import "./CotizacionCreate.vue?vue&type=style&index=0&id=a269aa66&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a269aa66"]])

export default __exports__